module.exports = "/_next/static/images/Hero-fe707deea7058c2dbbc799ffac826139.webp";